import { Screen } from '~/screens/clients/[clientId]/client-contracts/[termId]/edit';

/**
 * 企業契約期間 編集 Page
 */
export const ClientContractTermEditIndex = () => <Screen />;
